<template>
  <v-container fluid>
    <section v-if="!!fileData">
      <QuickNavigation :fileData="fileData" :routeHistory="$route" />
      <v-card v-if="fileData" class="my-4" color="background" flat tile>
        <v-row>
          <v-col cols="12" sm="6" xl="3">
            <v-simple-table class="table--striped" dense>
              <template v-slot:default>
                <thead>
                  <tr class="primary">
                    <th colspan="2">
                      <div class="font-weight-bold white--text">
                        <div class="text-body-1 text-uppercase">Borrower</div>
                        <div class="text-body-2 text-uppercase">
                          {{ fileData.applications[0].borrower.lastName }},
                          {{ fileData.applications[0].borrower.firstName }}
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="40%">Loan #</td>
                    <td>
                      {{ fileData.fileName }}
                    </td>
                  </tr>
                  <tr>
                    <td>Broker</td>
                    <td>{{ fileData.organization.name }}</td>
                  </tr>
                  <tr>
                    <td>Borrower Email</td>
                    <td>{{ fileData.applications[0].borrower.email }}</td>
                  </tr>
                  <tr>
                    <td>Home Phone</td>
                    <td>
                      {{
                        (fileData.applications[0].borrower.homePhone || "")
                          | VMask($store.state.mask.phone)
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Mobile Phone</td>
                    <td>
                      {{
                        (fileData.applications[0].borrower.mobilePhone || "")
                          | VMask($store.state.mask.phone)
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Mailing Address</td>
                    <td v-if="fileData.applications[0].borrower.mailingStreet">
                      {{
                        toFullAddress(
                          fileData.applications[0].borrower.mailingStreet,
                          fileData.applications[0].borrower.mailingCity,
                          fileData.applications[0].borrower.mailingState,
                          fileData.applications[0].borrower.mailingZip
                        )
                      }}
                    </td>
                    <td v-else>
                      {{
                        toFullAddress(
                          fileData.residences.find((x) => x.current).street,
                          fileData.residences.find((x) => x.current).city,
                          fileData.residences.find((x) => x.current).state,
                          fileData.residences.find((x) => x.current).zip
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="fileData.fileCreditScore">
                    <td>FICO</td>
                    <td>{{ fileData.fileCreditScore }}</td>
                  </tr>
                  <tr v-else>
                    <td><b>Estimated</b> FICO</td>
                    <td>{{ fileData.estimatedCreditScore }}</td>
                  </tr>
                  <tr>
                    <td>Vesting</td>
                    <td>{{ fileData.subProp.mannerTitleHeld }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="6" xl="3">
            <v-simple-table class="table--striped" dense>
              <template v-slot:default>
                <thead>
                  <tr class="primary">
                    <th colspan="2">
                      <div class="font-weight-bold white--text">
                        <div class="text-body-1 text-uppercase">Program</div>
                        <div class="text-body-2 text-uppercase">
                          <span v-if="fileData.loan.loanProgramName"
                            >{{ fileData.loan.loanProgramName }} [
                            {{ fileData.loan.loanProgramCode }} ]</span
                          >
                          <span v-else>No Product</span>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="40%">Purpose</td>
                    <td>
                      {{ fileData.loan.loanPurposeName }}
                    </td>
                  </tr>
                  <tr>
                    <td>Loan Term</td>
                    <td>{{ fileData.loan.term }}</td>
                  </tr>
                  <tr>
                    <td>Note Rate</td>
                    <td>{{ fileData.loan.intRate | percent(3, 1) }}</td>
                  </tr>
                  <tr>
                    <td>Qualified Rate</td>
                    <td>{{ fileData.loan.qualRate | percent(3, 1) }}</td>
                  </tr>
                  <tr>
                    <td>LTV / CLTV</td>
                    <td>
                      {{ fileData.loan.ltv | percent(2, 1) }} /
                      {{ fileData.loan.cltv | percent(2, 1) }}
                    </td>
                  </tr>
                  <tr>
                    <td>DTI</td>
                    <td>{{ fileData.loan.secondRatio | percent(2, 1) }}</td>
                  </tr>
                  <tr>
                    <td>Doc Type</td>
                    <td>{{ fileData.documentationTypeName }}</td>
                  </tr>
                  <tr>
                    <td>Occupancy Type</td>
                    <td>{{ fileData.occupancyTypeName }}</td>
                  </tr>
                  <tr
                    v-if="
                      fileData.customFields && fileData.customFields.field04
                    "
                  >
                    <td>Income Doc Type</td>
                    <td>{{ fileData.customFields.field04 }}</td>
                  </tr>
                  <tr>
                    <td>EST. Asset</td>
                    <td>
                      {{ fileData.totalAllLiquidAssets | currency() }}
                    </td>
                  </tr>
                  <tr>
                    <td>EST. Reserves</td>
                    <td>
                      {{
                        (fileData.customFields.field74 + "").replace(",", "")
                          | currency()
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>EST. Cash to close</td>
                    <td>{{ fileData.dot.cashFromToBorrower | currency() }}</td>
                  </tr>
                  <tr>
                    <td>Locked Date</td>
                    <td>
                      <span v-if="fileData.loan.lockStartDate">{{
                        fileData.loan.lockStartDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Lock Expiration Date</td>
                    <td>
                      <span v-if="fileData.loan.lockExpirationDate">{{
                        fileData.loan.lockExpirationDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="6" xl="3">
            <v-simple-table class="table--striped" dense>
              <template v-slot:default>
                <thead>
                  <tr class="primary">
                    <th colspan="2">
                      <div class="d-flex justify-space-between align-center">
                        <div class="font-weight-bold white--text">
                          <div class="text-body-1 text-uppercase">Status</div>
                          <div class="text-body-2 text-uppercase">
                            {{ fileData.status.loanStatusName }}
                          </div>
                        </div>
                        <v-btn
                          v-if="fileData.status.loanStatus == 11"
                          color="error"
                          @click="openSubPropDialog"
                        >
                          Convert to register status
                        </v-btn>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="40%">Registered Date</td>
                    <td>
                      <span v-if="fileData.status.customStatus2Date">{{
                        fileData.status.customStatus2Date | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Submission Cancelled Date</td>
                    <td>
                      <span v-if="fileData.status.customStatus11Date">{{
                        fileData.status.customStatus11Date
                          | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Submission Hold Date</td>
                    <td>
                      <span v-if="fileData.status.customStatus13Date">{{
                        fileData.status.customStatus13Date
                          | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Submitted Date</td>
                    <td>
                      <span v-if="fileData.status.submittedDate">{{
                        fileData.status.submittedDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>In UW Review Date</td>
                    <td>
                      <span v-if="fileData.status.resubmittedDate">{{
                        fileData.status.resubmittedDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Approved Date</td>
                    <td>
                      <span v-if="fileData.status.approvedDate">{{
                        fileData.status.approvedDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Clear To Close Date</td>
                    <td>
                      <span v-if="fileData.status.clearToCloseDate">{{
                        fileData.status.clearToCloseDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Doc Request Date</td>
                    <td>
                      <span v-if="fileData.extendedFields.docRequestDate">{{
                        fileData.extendedFields.docRequestDate
                          | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>ICD Sent Date</td>
                    <td>
                      <span v-if="fileData.extendedFields.icdSentDate">{{
                        fileData.extendedFields.icdSentDate
                          | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr> -->
                  <tr>
                    <td>Docs Out Date</td>
                    <td>
                      <span v-if="fileData.status.docsSentDate">{{
                        fileData.status.docsSentDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Docs-Back Date</td>
                    <td>
                      <span v-if="fileData.status.customStatus7Date">{{
                        fileData.status.customStatus7Date | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Requested Funding Date</td>
                    <td>
                      <span v-if="fileData.status.schedFundingDate">{{
                        fileData.status.schedFundingDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Funded Date</td>
                    <td>
                      <span v-if="fileData.status.fundingDate">{{
                        fileData.status.fundingDate | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>Comm. Check Issued Date</td>
                    <td>
                      <span v-if="fileData.extendedFields.checkSentDate">{{
                        fileData.extendedFields.checkSentDate
                          | moment("MM/DD/YYYY")
                      }}</span>
                    </td>
                  </tr> -->
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" sm="6" xl="3">
            <v-simple-table class="table--striped" dense>
              <template v-slot:default>
                <thead>
                  <tr class="primary">
                    <th colspan="2">
                      <div class="font-weight-bold white--text">
                        <div class="text-body-1 text-uppercase">Property</div>
                        <div class="text-body-2 text-uppercase">
                          {{
                            fileData.subProp.fullAddress
                              ? fileData.subProp.fullAddress
                              : "TBD"
                          }}
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="40%">Property Type</td>
                    <td>{{ fileData.subProp.propertyTypeName }}</td>
                  </tr>
                  <tr>
                    <td>Loan Amount</td>
                    <td>{{ fileData.loan.baseLoan | currency() }}</td>
                  </tr>
                  <tr>
                    <td>Property Appraisal Value</td>
                    <td>
                      {{ fileData.subProp.appraisedValue | currency() }}
                    </td>
                  </tr>
                  <tr>
                    <td>Sales Value</td>
                    <td>{{ fileData.loan.purPrice | currency() }}</td>
                  </tr>
                  <tr>
                    <td>Impound</td>
                    <td>{{ fileData.waiveEscrow != 1 ? "Yes" : "No" }}</td>
                  </tr>
                  <tr>
                    <td>P & I</td>
                    <td>{{ fileData.loan.pi | currency() }}</td>
                  </tr>
                  <tr>
                    <td>Tax</td>
                    <td>
                      {{ fileData.loan.proposedPropTaxesPayment | currency() }}
                    </td>
                  </tr>
                  <tr>
                    <td>Hazard Ins</td>
                    <td>
                      {{ fileData.loan.proposedHazPayment | currency() }}
                    </td>
                  </tr>
                  <tr>
                    <td>Mortgage Ins.</td>
                    <td>
                      {{ fileData.loan.proposedMipayment | currency() }}
                    </td>
                  </tr>
                  <tr>
                    <td>HOA</td>
                    <td>
                      {{ fileData.loan.proposedHodpayment | currency() }}
                    </td>
                  </tr>
                  <tr>
                    <td>Other</td>
                    <td>
                      <div
                        v-if="
                          !!fileData.loan.propOther ||
                          !!fileData.prepaidItems.find(
                            (x) => x.prepaidItemType == 3
                          ).payment
                        "
                      >
                        {{
                          (fileData.loan.propOther +
                            fileData.prepaidItems.find(
                              (x) => x.prepaidItemType == 3
                            ).payment)
                            | currency()
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        v-if="!!loanSteps"
        class="d-flex flex-row align-baseline px-4"
        flat
      >
        <div
          v-for="(loanStatus, index) in loanSteps"
          :key="'loan-status-' + index"
          class="text-center my-4"
          style="width: 600px"
        >
          <v-avatar :color="loanStatus.completed ? 'success' : 'grey'">
            <span class="text-subtitle-1 white--text">
              {{ index + 1 }}
            </span>
          </v-avatar>
          <div class="font-weight-bold">
            {{ loanStatus.loanStatusName }}
          </div>
        </div>
      </v-card>
      <v-skeleton-loader
        v-else
        class="mx-auto"
        height="100"
        type="image"
      ></v-skeleton-loader>
      <LoanDetailSubMenu />
    </section>
    <v-dialog v-model="subPropDialog.show" persistent width="700">
      <v-form ref="subPropForm">
        <v-card>
          <v-card-title class="d-flex align-center lightgrey">
            <span class="text-h6"> Edit Property Address </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="subPropDialog.show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="my-3">
            <v-row v-if="!!subPropDialog.subProp">
              <v-col cols="12">
                <v-text-field
                  label="Street"
                  v-model="subPropDialog.subProp.street"
                  :rules="[required]"
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="Zip"
                  v-model="subPropDialog.subProp.zip"
                  v-mask="'#####'"
                  :rules="[required, zipcode]"
                  outlined
                  @change="changeZip"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  id="city"
                  label="City"
                  v-model="subPropDialog.subProp.city"
                  :rules="[required]"
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  id="state"
                  label="State"
                  :items="subPropDialog.stateItems"
                  v-model="subPropDialog.subProp.state"
                  :rules="[required]"
                  item-value="codeValue"
                  item-text="codeValue"
                  outlined
                  hide-details="auto"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="changeLoanStatus"> Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";
import { common, convert, rules } from "@/mixins";

export default {
  name: "LoanDetail",
  components: {
    QuickNavigation,
    LoanDetailSubMenu,
  },
  async mounted() {
    const response = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.$route.query.loanNumber,
        option: "All",
      })
      .then((resp) => resp)
      .catch((err) => err);

    if (response.status === 200) {
      this.fileData = response.data;
      this.loanSteps = await this.$store
        .dispatch(
          "fileDataApi/getLoanStageStatus",
          this.$route.query.loanNumber
        )
        .then((resp) => resp.data)
        .catch(() => []);
    } else {
      this.$store.commit("statusDialog/showErrorDialog", response.data);
      this.$router.push("/pipeline");
    }
  },
  data() {
    return {
      param: this.$route.query.loanNumber,
      response: null,
      fileData: null,
      selectedSideMenu: null,
      loanSteps: null,
      subPropDialog: {
        show: false,
        subProp: null,
        stateItems: [],
      },
    };
  },
  methods: {
    async openSubPropDialog() {
      this.$store.commit("setGlobalLoading", true);
      this.subPropDialog.stateItems = await this.$store
        .dispatch("lookUpApi/getMstCodeVM", "State")
        .then((resp) => resp)
        .catch(() => []);

      this.subPropDialog.subProp = Object.assign({}, this.fileData.subProp);
      this.subPropDialog.show = true;
      this.$store.commit("setGlobalLoading", false);
    },
    async changeLoanStatus() {
      this.$store.commit("setGlobalLoading", true);
      try {
        if (this.$refs.subPropForm.validate()) {
          this.subPropDialog.subProp.propertyTbd = false;

          const subPropResult = await this.$store.dispatch(
            "subPropApi/update",
            {
              fileDataId: this.subPropDialog.subProp.fileDataId,
              subProp: this.subPropDialog.subProp,
            }
          );

          if (subPropResult.status == 200) {
            this.fileData.subProp = subPropResult.data;
          }

          this.fileData.status.loanStatus = 52;

          const statusResult = await this.$store.dispatch(
            "statusApi/updateOnlyLoanStatus",
            {
              fileDataId: this.fileData.status.fileDataId,
              status: this.fileData.status,
            }
          );

          if (statusResult.status == 200) {
            this.fileData.status = statusResult.data;

            this.loanSteps = await this.$store
              .dispatch(
                "fileDataApi/getLoanStageStatus",
                this.$route.query.loanNumber
              )
              .then((resp) => resp.data)
              .catch(() => []);
          }

          console.log(1);

          let fannie = await this.$store
            .dispatch("fannie/get", this.fileData.fileDataId)
            .then((resp) => resp.data)
            .catch(() => null);

          if (fannie != null) {
            fannie.caseFileId = null;

            fannie = await this.$store
              .dispatch("fannie/update", fannie)
              .then((resp) => resp.data)
              .catch(() => null);
          }
          console.log(2);

          const documentProperties = await this.$store
            .dispatch("documentProperty/get", this.fileData.fileDataId)
            .then((resp) => {
              return resp.data.filter((x) => x.documentName.startsWith("URLA"));
            })
            .catch(() => null);
          console.log(3);

          if (documentProperties) {
            for (let i = 0; i < this.fileData.applications.length; i++) {
              const disclosureModel = {
                loanNumber: this.fileData.fileName,
                applicationId: this.fileData.applications[i].applicationId,
                documentProperties: documentProperties,
              };

              const urlaDocumentBase64 = await this.$store
                .dispatch("disclosure/getPreview", disclosureModel)
                .then((resp) => resp.data)
                .catch(() => null);

              if (urlaDocumentBase64 != null) {
                await this.$store
                  .dispatch("embeddeddoc/createBarcodedDocument", {
                    fileDataId: this.fileData.fileDataId,
                    embeddedDocs: [{ documentData: urlaDocumentBase64 }],
                  })
                  .then((resp) => resp.data)
                  .catch(() => null);
              }
            }
          }

          await this.$store.dispatch(
            "loanRegistrationApi/sendLoanRegitrationNotification",
            this.fileData.fileDataId
          );

          this.$store.commit("statusDialog/show", {
            type: "success",
            message: "Your request has been successfully executed.",
          });

          this.subPropDialog.show = false;
        }
      } catch (error) {
        this.$store.commit("statusDialog/show", {
          type: "error",
          message: error,
        });
      }
      this.$store.commit("setGlobalLoading", false);
    },
    async changeZip() {
      if (
        this.subPropDialog.subProp.zip != null &&
        this.subPropDialog.subProp.zip.length >= 5
      ) {
        const resp = await this.$store
          .dispatch(
            "publicApi/getCityAndStateByZipcode",
            this.subPropDialog.subProp.zip
          )
          .catch((err) => err);

        if (resp.status == 200) {
          this.subPropDialog.subProp.state = resp.data.state;
          this.subPropDialog.subProp.city = resp.data.city;
          //
        }
      }
    },
  },
  mixins: [common, convert, rules],
};
</script>
